import dynamic from 'next/dynamic';

import { BlockLoadingSpinner } from 'components/LoadingSpinner';

import type { Props } from './AccountMenu';

const AccountMenuSuspense = dynamic(() => import('./AccountMenu'), {
	loading: () => <BlockLoadingSpinner size="small" />,
});

export default function DynamicAccountMenu(props: Props) {
	return <AccountMenuSuspense {...props} />;
}
DynamicAccountMenu.displayName = 'DynamicAccountMenu';
